/* tslint:disable */
/* eslint-disable */
// Custom GraphQL queries for Lambda authorizer authentication

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const customGetUser = /* GraphQL */ `
  query CustomGetUser(
    $id: ID!
    $accountsLimit: Int
    $accountsNextToken: String
  ) {
    getUser(id: $id) {
      id
      email
      name
      picture
      createdAt
      updatedAt
      accounts(limit: $accountsLimit, nextToken: $accountsNextToken) {
        items {
          id
          accountId
          userId
          createdAt
          updatedAt
          permissions
          account {
            id
            gid
            name
            mfaEnabled
            createdAt
            updatedAt
            tierId
            accountType {
              levelName
            }
          }
        }
        nextToken
      }
    }
  }
` as GeneratedQuery<
  APITypes.CustomGetUserQueryVariables,
  APITypes.CustomGetUserQuery
>;

export const customGetProject = /* GraphQL */ `
  query CustomGetProject($id: ID!) {
    getProject(id: $id) {
      id
      projectAccountId
      title
      account {
        id
        gid
        name
        aliasId
        minisiteDomain
        mfaEnabled
        tierId
        createNewVideosWithBlingLogo
        createdAt
        updatedAt
      }
      videoParts {
        name
        jsonUrl
        mods
        modsArr {
          id
          dataStr
          origin
          name
          description
        }
        fonts {
          family
          url
          weight
          style
        }
        updatedAt
        hasVideo
        origin
        playerVersionToUse
        description
      }
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      dataFiles {
        fileName
        tag
        createdAt
      }
      description
      fileName
      jsonChanges
      jsonVidUrl
      playerSettings {
        autoplay
        autoplay_delay
        posterFrame
        showTimeline
        storiesMode
        color_loader
        color_ctrlBtns
        color_rail
        color_progress
        color_thumb
        color_bg
        muted
        autoReplay
        showBlingsLogo
        blingsLogoColor
        loadingText
        loadingImage
      }
      projectVersions {
        nextToken
      }
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experiments {
        id
        type
        variants {
          id
          value
          successFactors {
            conversionSuccessData
            engagementSuccessData
            selectionCount
            watchTimeSuccessData
          }
        }
      }
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      minisiteConfigs {
        scenes
        title
        description
        thumbUrl
        faviconUrl
        preCreate
      }
      playerVersionToUse
      customHtml
      dynamicThumbnails {
        name
        id
        createdAt
        updatedAt
      }
      publishedAt
      allowedOrigins
      flowDiagram {
        nodes {
          id
          label
          data
          lineupId
          type
        }
        edges {
          source
          target
          sourceHandle
        }
      }
      textToVideoScript
      instantiatedFromUseCase
      overlay {
        audio {
          url
          volume
          loop
        }
      }
      fontOverrides {
        family
        url
        weight
        style
      }
      isDeleted
      updatedAt
    }
  }
` as GeneratedQuery<
  APITypes.GetProjectQueryVariables,
  APITypes.GetProjectQuery
>;
